import { calculateNativeGrossValue, getQuantityUnit } from '@einhaus/project314-shared';
import type { QuantityUnit, UserPortfolioPosition } from '@einhaus/project314-types';

type QuantityIdentity = Pick<UserPortfolioPosition, 'entityType' | 'derivativeType'> & { quantityUnit?: QuantityUnit };

export const resolveQuantityUnit = (instrument: QuantityIdentity): QuantityUnit => instrument.quantityUnit ?? getQuantityUnit(instrument);

export const getQuantityLabel = (instrument: QuantityIdentity): 'Shares' | 'Contracts' | 'Units' => {
    const unit = resolveQuantityUnit(instrument);
    return unit === 'share' ? 'Shares' : unit === 'contract' ? 'Contracts' : 'Units';
};

export const formatQuantity = (quantity: number | string): string =>
    Number(quantity).toLocaleString('en-US', { maximumFractionDigits: 18 });

export const formatQuantityWithUnit = (quantity: number | string, instrument: QuantityIdentity): string => {
    const unit = resolveQuantityUnit(instrument);
    return `${formatQuantity(quantity)} ${unit}${Number(quantity) === 1 ? '' : 's'}`;
};

export const formatNativeGrossValueEquation = ({
    instrument,
    quantity,
    quotedPrice,
    contractMultiplier
}: {
    instrument: QuantityIdentity;
    quantity: number | string;
    quotedPrice: number | string;
    contractMultiplier: number | string;
}): string => {
    const quotedPriceLabel = resolveQuantityUnit(instrument) === 'contract' ? ' premium quote' : '';
    const grossValue = calculateNativeGrossValue({
        instrument,
        quantity: Number(quantity),
        price: Number(quotedPrice),
        contractMultiplier: Number(contractMultiplier),
        allowZero: true
    });

    return `${formatQuantityWithUnit(quantity, instrument)} × $${formatQuantity(quotedPrice)}${quotedPriceLabel} × ${formatQuantity(contractMultiplier)} = $${formatQuantity(grossValue)} gross`;
};
